// Match the site's genre palette, including canonical and short display names.
const genreColors = [
  ["#541675", ["Bookish Circle"]],
  ["#7A5C8E", ["Literary", "Literary Fiction"]],
  ["#E6B7C6", ["Christian", "Religion / Spirituality"]],
  ["#FF1D8D", ["Romance"]],
  ["#B832C9", ["Romantasy"]],
  ["#990000", ["Horror"]],
  ["#704214", ["Western"]],
  ["#E36A2E", ["Historical", "Historical Fiction", "History"]],
  ["#F4C430", ["Children", "Children's", "Children's Books"]],
  ["#1E7F5C", ["Fantasy"]],
  ["#1F4ED8", ["Sci-Fi", "Science Fiction"]],
  ["#0F2A44", ["Thriller", "Thriller / Suspense"]],
  ["#4A5560", ["Non-Fiction", "Biography / Memoir", "Self-Help / Personal Development", "Science / Nature", "Travel / Adventure", "Essays"]],
  ["#3A3F45", ["Crime", "True Crime"]],
  ["#2C2C2C", ["Mystery", "Mystery / Crime"]],
];

const normalize = (name) => String(name || "").toLowerCase().replace(/[^a-z0-9]/g, "");
const colorsByName = new Map(genreColors.flatMap(([color, names]) => names.map((name) => [normalize(name), color])));

export const genreColor = (name) => colorsByName.get(normalize(name)) || "#541675";
